<mat-form-field>
  <mat-label>{{placeholder}}</mat-label>
    <mat-select name="Division" [(ngModel)]="value" [multiple]="multiple" #selector
                [required]="required" [disabled]="disabled" [compareWith]="compareWith">
        <mat-option *ngIf="allOption" (onSelectionChange)="toggle($event)">Alles selecteren</mat-option>
        <hr *ngIf="allOption">
        <mat-option *ngFor="let opt of Divisions" [value]="getOnlyId ? opt.Id : opt">{{opt.CompanyName}}</mat-option>
    </mat-select>
</mat-form-field>
